<template>
  <div class="branch">
    <div class="value">{{ location.number }}</div>
    <div class="value secondary-text">{{ location.city }}</div>
    <div class="value secondary-text">{{ location.address }}</div>
  </div>
</template>
<script>
export default {
	name: 'Branch-Tile',

	computed : {

	},
	components : {
	},
	props: {
		location : Object
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.branch{
  // border-bottom:1px solid #DCDFE6;
  line-height:20px;
  padding-top:10px;
  padding-bottom:10px;
}

</style>
